// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 284 ? "ba1712fc" : chunkId) + "." + {"284":"99a2329ad45d3aac","828":"abadb05e2a6589cc"}[chunkId] + ".js";
};